import { cache } from 'react';
import { Product } from '../types/Header';

export const fetchProducts = cache(async (page?: number, searchQuery?: string, url?: string): Promise<Product[]> => {
  try {
    const fetchAllProducts = !page && !searchQuery;
    const response = fetchAllProducts
      ? await fetch(`${url ?? ''}/api/products`)
      : await fetch(`${url ?? ''}/api/products?page=${page}&query=${encodeURIComponent(searchQuery ?? '')}`);

    if (!response.ok) {
      throw new Error('Failed to fetch products');
    }
    return await response.json();
  } catch (error) {
    console.error(error);
    return [];
  }
})
